/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Auth_HeadingInputs */

const en_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to finish booking`)
};

const es_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión para terminar la reserva`)
};

const de_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melden Sie sich an, um die Buchung abzuschließen`)
};

const zh_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录以完成预订`)
};

const ar_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجّل الدخول لإتمام الحجز`)
};

const fr_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous pour terminer la réservation`)
};

const vi_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập để hoàn tất đặt chỗ`)
};

const sw_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingia ili ukamilishe kuweka nafasi`)
};

const th_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลงชื่อเข้าใช้เพื่อทำการจองให้เสร็จสมบูรณ์`)
};

const bs_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijavite se da završite rezervaciju`)
};

const ja_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予約を完了するためにサインイン`)
};

const ko_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예약을 완료하려면 로그인하세요`)
};

const pt_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre para concluir a reserva`)
};

const it_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi per completare la prenotazione`)
};

const sv_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logga in för att slutföra bokningen`)
};

const nl_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanmelden om te boeken`)
};

const da_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log ind for at gennemføre bookingen`)
};

const nb_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logg inn for å fullføre bestillingen`)
};

const fi_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjaudu sisään viimeistelläksesi varauksen`)
};

const pl_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się, aby dokończyć rezerwację`)
};

const ru_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войдите, чтобы закончить бронирование`)
};

const tr_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervasyonu tamamlamak için giriş yapın`)
};

const hi_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बुकिंग पूरी करने के लिए साइन इन करें`)
};

const id_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk untuk menyelesaikan pemesanan`)
};

const ms_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log masuk untuk melengkapkan tempahan`)
};

const cs_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlaste se k dokončení rezervace`)
};

const el_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Συνδεθείτε για να ολοκληρώσετε την κράτηση`)
};

const he_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התחברו כדי להשלים את ההזמנה`)
};

const af_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meld aan om die bespreking te voltooi`)
};

const hu_booking_auth_heading = /** @type {(inputs: Booking_Auth_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bejelentkezés a foglalás befejezéséhez`)
};

/**
* | output |
* | --- |
* | "Sign in to finish booking" |
*
* @param {Booking_Auth_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_auth_heading = /** @type {((inputs?: Booking_Auth_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Auth_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_auth_heading(inputs)
	if (locale === "de") return de_booking_auth_heading(inputs)
	if (locale === "zh") return zh_booking_auth_heading(inputs)
	if (locale === "ar") return ar_booking_auth_heading(inputs)
	if (locale === "fr") return fr_booking_auth_heading(inputs)
	if (locale === "vi") return vi_booking_auth_heading(inputs)
	if (locale === "sw") return sw_booking_auth_heading(inputs)
	if (locale === "th") return th_booking_auth_heading(inputs)
	if (locale === "bs") return bs_booking_auth_heading(inputs)
	if (locale === "ja") return ja_booking_auth_heading(inputs)
	if (locale === "ko") return ko_booking_auth_heading(inputs)
	if (locale === "pt") return pt_booking_auth_heading(inputs)
	if (locale === "it") return it_booking_auth_heading(inputs)
	if (locale === "sv") return sv_booking_auth_heading(inputs)
	if (locale === "nl") return nl_booking_auth_heading(inputs)
	if (locale === "da") return da_booking_auth_heading(inputs)
	if (locale === "nb") return nb_booking_auth_heading(inputs)
	if (locale === "fi") return fi_booking_auth_heading(inputs)
	if (locale === "pl") return pl_booking_auth_heading(inputs)
	if (locale === "ru") return ru_booking_auth_heading(inputs)
	if (locale === "tr") return tr_booking_auth_heading(inputs)
	if (locale === "hi") return hi_booking_auth_heading(inputs)
	if (locale === "id") return id_booking_auth_heading(inputs)
	if (locale === "ms") return ms_booking_auth_heading(inputs)
	if (locale === "cs") return cs_booking_auth_heading(inputs)
	if (locale === "el") return el_booking_auth_heading(inputs)
	if (locale === "he") return he_booking_auth_heading(inputs)
	if (locale === "af") return af_booking_auth_heading(inputs)
	if (locale === "hu") return hu_booking_auth_heading(inputs)
	return en_booking_auth_heading(inputs)
});